import React from 'react';
import './style.css';
import '../style.css';
import Label from '../Label';
import ErrorLabel from '../Label/ErrorLabel';

export type TextInputProps = {
	label?: string;
	error?: string;
	required?: boolean;
	inputContainerStyle?: React.CSSProperties;
	containerStyle?: React.CSSProperties;
	component?: React.ReactNode;
	leftIcon?: React.ReactElement;
	rightIcon?: React.ReactNode;
	containerClassName?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export default function Input({
	label,
	required,
	error,
	leftIcon,
	containerClassName = 'mb-10',
	inputContainerStyle,
	containerStyle,
	component,
	rightIcon,
	...inputProps
}: TextInputProps): JSX.Element {
	leftIcon = leftIcon ? (
		<div style={{ width: 26, position: 'absolute', paddingLeft: 10 }}>
			{leftIcon}
		</div>
	) : undefined;

	rightIcon = rightIcon ? (
		<div style={{ width: 26, position: 'absolute', right: 10 }}>
			{rightIcon}
		</div>
	) : undefined;

	return (
		<div style={containerStyle} className={`${containerClassName}`}>
			{label ? <Label text={label} required={required} /> : null}
			<div style={{ display: 'flex' }}>
				<div
					style={{
						position: 'relative',
						display: 'flex',
						alignItems: 'center',
						flex: 1,
						...inputContainerStyle,
					}}
				>
					{leftIcon}
					<input
						style={{ padding: '12px 12px' }}
						className={`form-control form-control-solid ${
							leftIcon ? 'ps-10' : ''
						}`}
						{...inputProps}
					/>
					{rightIcon}
				</div>
				{component}
			</div>
			{error ? <ErrorLabel text={error} className="mt-5" /> : null}
		</div>
	);
}
